import httpServer from "../axios";
import {baseUrlt} from "..";

export default {
  // 省
  getJournas(params) {
    return httpServer('post',`${baseUrlt}api/class/train/log/list`, params);
  },
  getRooms(params) {
    return httpServer('get',`${baseUrlt}api/training/room/list`, params);
  },
  getJournasOfClass(params) {
    return httpServer('post',`${baseUrlt}api/class/train/class_log/list`, params);
  },
  getJournasOfTeacher(params) {
    return httpServer('post',`${baseUrlt}api/class/charge/list`, params);
  },
  getDeviceIntoList(params) {
    return httpServer('get',`${baseUrlt}api/device/list`, params);
  },
  getDeviceBuyList(params) {
    return httpServer('get',`${baseUrlt}api/devicepurchase/list`, params);
  },
  getDevicescrapList(params) {
    return httpServer('get',`${baseUrlt}api/devicescrap/list`, params);
  },
  getDeviceRepairList(params) {
    return httpServer('get',`${baseUrlt}api/devicerepair/list`, params);
  },
  getDeviceKeepList(params) {
    return httpServer('get',`${baseUrlt}api/devicekeep/list`, params);
  },
  getDeviceBorrowList(params) {
    return httpServer('get',`${baseUrlt}api/deviceborrow/list`, params);
  },
  getDeviceLendList(params) {
    return httpServer('get',`${baseUrlt}api/devicelend/list`, params);
  },
  getDeviceReturnList(params) {
    return httpServer('get',`${baseUrlt}api/devicereturn/list`, params);
  },
  getDeviceCountList(params) {
    return httpServer('get',`${baseUrlt}api/devicetotal/list`, params);
  },
  getClassTearchList(params) {
    return httpServer('get',`${baseUrlt}api/room/order/class_teacher/list`, params);
  },
  getTrainTearchList(params) {
    return httpServer('get',`${baseUrlt}api/room/order/train_teacher/list`, params);
  },
  getClassPlanList(params) {
    // return httpServer('get',`${baseUrlt}api/class/plan/list`, params);
    return httpServer('get',`${baseUrlt}api/xmhy/class/plan/list`, params);
  },
  getConsumeIntoList(params) {
    return httpServer('post',`${baseUrlt}api/consume/query`, params);
  },
  getConsumeUseList(params) {
    return httpServer('post',`${baseUrlt}api/consume/record/query`, params);
  },
  getConsumeSurplusList(params) {
    return httpServer('post',`${baseUrlt}api/consume/remainder/query`, params);
  },
  getNotices(params) {
    return httpServer('post',`${baseUrlt}api/notice/list`, params);
  },
  getNoticesUnload(params) {
    return httpServer('post',`${baseUrlt}api/notice/list`, params,{isLoadd:false});
  },
  getUsers(params) {
    return httpServer('get',`${baseUrlt}api/user/list`, params);
  },
  getUsersUnLoad(params) {
    return httpServer('get',`${baseUrlt}api/user/list`, params,{isLoadd:false});
  },
  getCourses(params) {
    return httpServer('get',`${baseUrlt}api/grade/list`, params);
  },
  getQulityItems(params) {
    return httpServer('get',`${baseUrlt}api/grade/index`, params);
  },
  getQulityGrades(params) {
    return httpServer('get',`${baseUrlt}api/training/student/score/list`, params);
  },
  getQulityAdvices(params) {
    return httpServer('get',`${baseUrlt}api/training/course/score/list`, params);
  },
  getStudentTras(params) {
    return httpServer('get',`${baseUrlt}api/student/course/list`, params);
  },
  getFiles(params) {
    return httpServer('post',`${baseUrlt}api/file/list`, params);
  },
  getFilesUnload(params) {
    return httpServer('post',`${baseUrlt}api/file/list`, params,{isLoadd:false});
  },
  getDevicesAlreadyBind(params) {
    return httpServer('get',`${baseUrlt}api/training/room/device/list`, params);
  },
  getSafes(params) {
    return httpServer('get',`${baseUrlt}api/training/room/standard/list`, params);
  },
  getEqCg(params) {
    return httpServer('get',`${baseUrlt}api/training/room/device/purchaselist`, params);
  },
  getEqRk(params) {
    return httpServer('get',`${baseUrlt}api/training/room/device/storagelist`, params);
  },
  getEqSY(params) {
    return httpServer('get',`${baseUrlt}api/training/room/device/uselist`, params);
  },
  getEqWX(params) {
    return httpServer('get',`${baseUrlt}api/training/room/device/repairrecord`, params);
  },
  getEqYY(params) {
    return httpServer('get',`${baseUrlt}api/training/room/device/orderrecord`, params);
  },
  room_use() {
    // return httpServer('get',`${baseUrlt}api/stats/training/room_use`, );
    return httpServer('get',`${baseUrlt}api/stats/training/room_use_hour`, );
  },
  teacher_class() {
    return httpServer('get',`${baseUrlt}api/stats/training/teacher_class`, );
  },
  room_device() {
    return httpServer('get',`${baseUrlt}api/stats/training/room_device`, );
  },
  device_wear() {
    return httpServer('get',`${baseUrlt}api/stats/training/device_wear`, );
  },
  device_capital() {
    return httpServer('get',`${baseUrlt}api/stats/training/device_capital`, );
  },
  student_sign() {
    return httpServer('get',`${baseUrlt}api/stats/training/student_sign`, );
  },
  getAdminPlanes(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/admin/list`,  params);
  },
  getAdminPlanesV2(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/v2/list`,  params);
  },
  getTeacherPlanes(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/teacher/list`,  params);
  },
  getStudentPlanes(params) {
    return httpServer('get',`${baseUrlt}api/student/training_plan/availableList`,  params);
  },
  getStudentPlanesed(params) {
    return httpServer('get',`${baseUrlt}api/student/training_plan/list`,  params);
  },
  getStudentApplys(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/teacher/studentApplyList`,  params);
  },
  getPlanStudents(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/studentList`,  params);
  },
  getConsumeds(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/consumedList`,  params);
  },
  getConsumedRecord(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/consumedRecord`,  params);
  },
  getStudentScore(params) {
    return httpServer('post',`${baseUrlt}api/training_plan/student/score`, params);
  },
  getTrainConfig(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/planScoreItemList`, params);
  },
  getTrainBase(params) {
    return httpServer('get',`${baseUrlt}api/training_base/list`, params);
  },
  getMessages(params) {
    return httpServer('get',`${baseUrlt}api/message/myList`, params);
  },
  getSchools(params) {
    return httpServer('get',`${baseUrlt}api/school/admin/list`, params);
  },
  getTrainOpen(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_room/open/list`, params);
  },
  getTrainCup(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_room/computer_use/list`, params);
  },
  getTrainCupCount(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_room/computer_use/sum`, params);
  },
  getTrainFunds(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_room/funds/list`, params);
  },
  getStudentScores(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/admin/studentScoreList`, params);
  },
  getTrainBaseOut(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_base_out/list`, params);
  },
  getTrainConfig(params) {
    return httpServer('get',`${baseUrlt}api/training_plan/planScoreItemList`, params);
  },
  getTrainOutConfig(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_base_out/baseScoreItemList`, params);
  },
  getTrainOutYearConfig(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/training_base_out/baseScoreYearList`, params);
  },
  getSumSxStudent(params) {
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/sumSxStudent`, params);
  },
  getTermms(params) {
    return httpServer('get',`${baseUrlt}api/xmhy/class/plan/termList`, params);
  },
  getPurchaseAdmin(params) {
    return httpServer('post',`${baseUrlt}api/consume/purchase/listAll`, params);
  },
  getDevicePurchaseAdmin(params) {
    return httpServer('post',`${baseUrlt}api/device/purchase2/listAll`, params);
  },
  getPurchaseMine(params) {
    return httpServer('post',`${baseUrlt}api/consume/purchase/listMy`, params);
  },
  getDevicePurchaseMine(params) {
    return httpServer('post',`${baseUrlt}api/device/purchase2/listMy`, params);
  },
  getLogAll(params) {
    return httpServer('post',`${baseUrlt}api/class/train/log/listAll`, params);
  },
  getClassStudents(params) {
    return httpServer('get',`${baseUrlt}api/teacher/class_student_list`, params);
  },
  getXycollect(params) {
    return httpServer('get',`${baseUrlt}api/device/xycollect`, params);
  },
  getConsumeXycollect(params) {
    return httpServer('get',`${baseUrlt}api/consume/xycollect`, params);
  },
  getTrainXycollect(params) {
    return httpServer('get',`${baseUrlt}api/training/room/xycollect`, params);
  },
};